<script setup>
import { inject, onMounted, ref } from 'vue';
import { useFlagStore } from '@/store';
defineOptions({
  name: 'ModalElement',
});
const props = defineProps(['modal']);

const store = useFlagStore();
const proceedbutton = ref(null);
const okcancelbutton = ref(null);
const emitter = inject('emitter');
const no = () => {
  store.closeModal(props.modal.id);
  emitter.emit(props.modal.eventName + '-no');
};
const yes = () => {
  store.closeModal(props.modal.id);
  emitter.emit(props.modal.eventName + '-yes', props.modal.param);
};
const proceed = () => {
  store.closeModal(props.modal.id);
  emitter.emit(props.modal.eventName + '-proceed');
};

onMounted(() => {
  if (proceedbutton.value != null) {
    proceedbutton.value.focus();
  }
  if (okcancelbutton.value != null) {
    okcancelbutton.value.focus();
  }
  if (props.modal.type == 'autonotification') {
    setTimeout(() => {
      store.closeModal(props.modal.id);
    }, 1500);
  }
});
</script>
<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ modal.title }}</p>
      </header>
      <section class="modal-card-body">
        <p v-html="modal.content"></p>
      </section>
      <footer class="modal-card-foot">
        <button
          v-if="modal.type == 'notification'"
          ref="proceedbutton"
          class="button is-success"
          @click="proceed"
        >
          OK
        </button>
        <button
          v-if="modal.type == 'okcancel'"
          ref="okcancelbutton"
          class="button is-success"
          @click="yes"
        >
          OK
        </button>
        <button
          v-if="modal.type == 'okcancel'"
          class="button is-warning"
          @click="no"
        >
          cancel
        </button>
      </footer>
    </div>
  </div>
</template>
<style>
.modal {
  --background: #fff;
  --offset: 0px;
  --radius-large: var(--button-size);
  --modal-background-color: rgba(32, 32, 32, 0.4);

  --modal-content-width: 440px;
  --modal-content-margin-mobile: 20px;
  --modal-content-spacing-mobile: 160px;
  --modal-content-spacing-tablet: 40px;

  --modal-close-dimensions: 40px;
  --modal-close-right: 20px;
  --modal-close-top: 20px;

  --modal-card-spacing: calc(3 * var(--default-margin));

  --modal-card-head-background-color: var(--light-blue);
  --modal-card-head-border-bottom: 0px solid black;
  --modal-card-head-padding: calc(2 * var(--default-margin));
  --modal-card-head-radius: var(--radius-large);

  --modal-card-title-color: white;
  --modal-card-title-line-height: 1;
  --modal-card-title-size: calc(0.6 * var(--button-size));

  --modal-card-foot-background-color: var(--light-blue);
  --modal-card-foot-radius: var(--radius-large);
  --modal-card-foot-padding: calc(1 * var(--default-margin));
  --modal-card-foot-border-top: 0px solid black;

  --modal-card-body-background-color: var(--light-blue);
  --modal-card-body-padding: var(--default-margin)
    calc(3 * var(--default-margin));

  --modal-breakpoint: 960px;

  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  z-index: 40;
  &.is-active {
    display: flex;
  }

  bottom: var(--offset);
  left: var(--offset);
  position: absolute;
  right: var(--offset);
  top: var(--offset);
}
.modal-background {
  background-color: var(--modal-background-color);
  bottom: var(--offset);
  left: var(--offset);
  position: absolute;
  right: var(--offset);
  top: var(--offset);
}
.modal-content,
.modal-card {
  margin: 0 var(--modal-content-margin-mobile);
  max-height: calc(100vh - var(--modal-content-spacing-mobile));
  overflow: auto;
  position: relative;
  min-width: calc(0.4 * var(--modal-breakpoint));
  @media (min-width: var(--modal-breakpoint)) {
    margin: 0 auto;
    max-height: calc(100vh - var(--modal-content-spacing-tablet));
    width: var(--modal-content-width);
  }
}
.modal-close {
  background: none;
  height: var(--modal-close-dimensions);
  position: fixed;
  top: var(--modal-close-top);
  width: var(--modal-close-dimensions);
}

.modal-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - var(--modal-card-spacing));
  overflow: hidden;
  margin: var(--modal-card-spacing);
}
.modal-card-head,
.modal-card-foot {
  align-items: center;
  background-color: var(--modal-card-head-background-color);
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  position: relative;
}

.modal-card-foot {
  justify-content: center;
}
.modal-card-head {
  padding: var(--modal-card-head-padding);
  border-bottom: var(--modal-card-head-border-bottom);
  border-top-left-radius: var(--modal-card-head-radius);
  border-top-right-radius: var(--modal-card-head-radius);
}

.modal-card-title {
  color: var(--modal-card-title-color);
  flex-grow: 1;
  flex-shrink: 0;
  font-size: var(--modal-card-title-size);
  line-height: var(--modal-card-title-line-height);
}

.modal-card-foot {
  border-bottom-left-radius: var(--modal-card-foot-radius);
  border-bottom-right-radius: var(--modal-card-foot-radius);
  border-top: var(--modal-card-foot-border-top);
}
.modal-card-body {
  background-color: var(--modal-card-body-background-color);
  flex-grow: 1;
  flex-shrink: 1;
  overflow: auto;
  padding: var(--modal-card-body-padding);
}
</style>
